import { getEnrollmentContractStatuses, setEnrollmentContractStatus, setEnrollmentPaymentOption } from '../../api/sponteAPI';
import { requireConfirmedEnrollmentStatus } from '../../utils/enrollmentStatus';

const scalar = value => Array.isArray(value) ? scalar(value[0]) : value && typeof value === 'object' && '_' in value ? scalar(value._) : String(value ?? '').trim();
export const enrollmentReportStudentId = row => scalar(row?.AlunoID || row?.AlunoId || row?.AlunoIDMatricula || row?.AlunoIdSponte);
export const indexEnrollmentStatuses = rows => Object.fromEntries((rows || []).map(row => [scalar(row.studentExternalId || row.student_external_id || row.AlunoID), row]).filter(([id]) => id));

// Uma consulta ao armazenamento local, sem carregar fichas individuais da Sponte.
export async function loadEnrollmentReportStatuses(schoolYear, enrollments) {
  const ids = [...new Set(enrollments.map(enrollmentReportStudentId).filter(Boolean))];
  if (!ids.length) return {};
  const statuses = await getEnrollmentContractStatuses(schoolYear, ids);
  if (!Array.isArray(statuses)) throw new Error('Não foi possível carregar os dados salvos.');
  return indexEnrollmentStatuses(statuses);
}

export async function saveEnrollmentReportStatus(studentId, schoolYear, changes, snapshot) {
  const patch = {};
  if (changes.updatePayment) patch.paymentOption = changes.paymentOption;
  if (changes.updateContract) patch.contractSigned = changes.contractSigned;
  if (changes.updateImageAuthorization) patch.imageAuthorization = changes.imageAuthorization;
  if (changes.updateImageRestrictions) patch.imageRestrictions = changes.imageRestrictions;
  let observation;
  let status;
  if (changes.updatePayment) {
    const result = await setEnrollmentPaymentOption(studentId, patch.paymentOption, {
      schoolYear, enrollmentSnapshot: { ...snapshot, ...patch },
    });
    observation = result?.Observacao;
    status = result?.enrollmentContractStatus;
  }
  // Compatibilidade com backend anterior que não devolvia o registro no pagamento.
  if (!status) status = await setEnrollmentContractStatus(studentId, { schoolYear, ...patch, enrollmentSnapshot: snapshot });
  requireConfirmedEnrollmentStatus(status);
  for (const [field, value] of Object.entries(patch)) {
    if ((value === '' && ['imageAuthorization', 'imageRestrictions'].includes(field) && status[field] !== '') || String(status[field] ?? '') !== String(value ?? '')) {
      throw new Error('O retorno da gravação difere da alteração solicitada. Atualize o relatório para conferir antes de tentar novamente.');
    }
  }
  return { status, observation };
}
